/**
 * Schmale Schnittstelle „Teilen“ zwischen der Plattform (Anmeldung, Cloud)
 * und einem Build (z. B. Lead Sheets). Der Build kennt Firebase nicht: Er
 * fragt nur, ob Teilen geht, wer ihn benutzt und wer sonst da ist.
 *
 * Gesetzt von firebase/start.ts nach der Anmeldung; ohne Cloud (lokale
 * Fassung) bleibt sie leer und die Oberflaeche zeigt kein „Teilen“.
 */

export interface SharingPersonInfo {
  id: string;
  name: string;
}

export interface SharingApi {
  /** Eigene Konto-Id. */
  me: string;
  /** Freigaben eingerichtet (Umschalter aktiv)? Vorher gibt es kein „Teilen“. */
  enabled(): boolean;
  /** Freigeschaltete Personen zum Auswaehlen (nur Namen). */
  people(): Promise<SharingPersonInfo[]>;
  /** Groesse eines Projekts in Bytes. */
  projectBytes(projectId: string): number;
  /** Speicher je Konto in Bytes (Schnittstelle Rot Cloud). */
  quotaBytes: number;
  /** Ausdruecklich vergebene hoechste Stufe: darf Freigaben aendern, wo man mitarbeitet. */
  canManageShared?(): boolean;
}

let api: SharingApi | null = null;

export function setSharingApi(next: SharingApi | null): void {
  api = next;
}

export function sharingApi(): SharingApi | null {
  return api?.enabled() ? api : null;
}

/** Auch vor dem Einrichten der Freigaben – nur zum Anzeigen (Speicher). */
export function sharingApiAny(): SharingApi | null {
  return api;
}
